import script from "./PositionTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./PositionTable.vue?vue&type=script&lang=ts&setup=true"

import "./PositionTable.vue?vue&type=style&index=0&id=05dc6ee6&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05dc6ee6"]])

export default __exports__